// components/menus/SectionGrid.tsx

import getLink from "@/lib/storyblok/utils/getLink";
import { MenuSectionStoryblok } from "@/types/storyblok-blok-types";
import * as Dialog from "@radix-ui/react-dialog";
import clsx from "clsx";
import Link from "next/link";
import { FeaturedContentBlok } from "../../FeaturedContentBlok";
import styles from "./header-bloks.module.css";

export const SectionGrid = ({
  section,
  closeDialog = false,
  isCurated,
  isDenim,
}: {
  section: MenuSectionStoryblok;
  closeDialog?: boolean;
  isCurated?: boolean;
  isDenim?: boolean;
}) => {
  if (!section) return null;

  const hasFeatured = (section.featuredContent?.length ?? 0) > 0;

  return (
    <div className={styles.section__grid}>
      {section.links && section.links.length > 0 && (
        <div className={styles.section__links}>
          {section.links?.map(link => {
            const href = getLink(link.link);
            const linkElement = <Link href={href ?? "#"}>{link.text}</Link>;

            return (
              <p key={link._uid} className={styles.menu__item__link}>
                {closeDialog ? (
                  <Dialog.Close asChild>{linkElement}</Dialog.Close>
                ) : (
                  linkElement
                )}
              </p>
            );
          })}
        </div>
      )}

      {hasFeatured && isDenim && (
        <h2 className={styles.section__title}>{section.title}</h2>
      )}

      {hasFeatured && (
        <div className={clsx(isCurated && styles.curatedRow)}>
          {section.featuredContent?.map(blok => (
            <FeaturedContentBlok
              key={blok._uid}
              blok={blok}
              isCurated={isCurated}
              closeDialog={closeDialog}
            />
          ))}
        </div>
      )}
    </div>
  );
};
